/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { observer } from 'mobx-react';

import CanvasTabs from 'components/canvasTabs/CanvasTabs';
import CSSTransition from 'react-transition-group/CSSTransition';

@observer
class ExploreContainerItem extends Component {

	componentDidUpdate() {
		const item = this.props.item;
		const model = this._findModel( this.props.containerModel, item.id );
		const background =  model && model.isCurrentThumbnail;
		const done = model && model.isDoneThumbnail;
		if (background === true && !done && !this.props.item.displayed) {
			model.renderThumbnail(item.id);
		}
	}


	render() {
		const item = this.props.item;
		const model = this._findModel( this.props.containerModel, item.id );

		const background =  model && model.isCurrentThumbnail;

		const done = model && model.isDoneThumbnail;
		const isDisplayed = model && model.isDisplayed || item.displayed;
		const visible = isDisplayed|| background || done;

		const isBackground = background && !isDisplayed;
		const isDone = done && !isDisplayed;

		const classes = classNames({
			'card-item': true,
			'background': isBackground,
			'done': isDone
		});

		const sidePanel = this.renderSidePanel(model);

		return (
			<div
				id={item.id}
				className={classes}
				data-id={item.id}
				style={{
					display: visible ? '' : 'none'
				}}
			>
				{item.render(visible)}
				{sidePanel}
			</div>
		);
	}

	_findModel(parentModel, itemId) {
		let model;

		const items = parentModel && parentModel.items || [];

		items.some( (item) => {
			if(item.id === itemId) {
				model = item;
				return true;
			}
		});

		return model;
	}

	renderSidePanel(model) {
		const { services, exploreVM } = this.props;

		if( !model || !model.canvasTabs ) {
			return null;
		}

		const canvasTabsModel = model.canvasTabs;
		const showSidePanel = model.canShowCanvasSidePanel;
		const isDisplayed = model.isDisplayed;

		// TODO: exploreVM should not be passed down to canvasTabs as it can lead to performance issues when there
		// are a lot of cards

		return (
			<CSSTransition
				in={showSidePanel}
				timeout={300}
				mountOnEnter={true}
				unmountOnExit={true}
				classNames={'explore__animation--slideLeft'}
			>
				<CanvasTabs
					services={services}
					exploreVM={exploreVM}
					model={canvasTabsModel}
					className="card-layout-content__side-panel"
					tabIndex={-1}
					isDisplayed={isDisplayed}
				/>
			</CSSTransition>
		);
	}
}

ExploreContainerItem.propTypes = {
	item: PropTypes.object.isRequired,
	services: PropTypes.object.isRequired,
	exploreVM: PropTypes.object,
	containerModel: PropTypes.object,
	background: PropTypes.bool,
	sidePanel: PropTypes.object
};

export default ExploreContainerItem;



// WEBPACK FOOTER //
// ./src/js/layout/explorecontainer/ExploreContainerItem.js